/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import "react-calendar/dist/Calendar.css";

///Images

//Import
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../../../context/ThemeContext";
import { fetchborrowerData } from "../../../store/reducers/broker";
import { fetchDriverData } from "../../../store/reducers/driver";

const Home = () => {
  const dispatch = useDispatch();
  const driverData = useSelector((state) => state.driver.driverCount);
  const borrowerdata = useSelector((state) => state.broker.borrowerCount);

  useEffect(() => {
    dispatch(fetchDriverData());
    dispatch(fetchborrowerData());
  }, []);
  console.log(driverData, "<===checking");

  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    changeBackground({ value: "dark", label: "dark" });
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-xl-4 col-sm-4">
          <div className="card gradient-1 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">1</h2>
                <span className="fs-18">User</span>
              </div>
              <img src="/img/group.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-4">
          <div className="card gradient-2 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">{borrowerdata}</h2>
                <span className="fs-18">Broker</span>
              </div>
              <img src="/img/employee.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-4">
          <div className="card gradient-3 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">{driverData}</h2>
                <span className="fs-18">Driver</span>
              </div>
              <img src="/img/driver.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
